App.LoyaltyProgramsEditController = Em.Controller.extend
  session: Em.inject.service()
  notifier: Em.inject.service()

  env:     Em.inject.service('environment')
  loyaltyEnabled: Em.computed.alias('env.features.loyaltyProgramsEnabled')

  needs: [ 'loyalty-programs', 'loyaltyProgramsIndex' ]

  loyaltyProgramBinding: 'model'

  additionalInfoBinding: 'controllers.loyalty-programs.model.additionalInfo'

  isLoading: false

  mappedKinds:(->
    info = @get('additionalInfo')
    info.map (info) => 
      info.translation = info.locales[Em.I18n.locale]
      info
  ).property('additionalInfo')
  

  actions:
    handleKindSelected: ->
      loyaltyProgram = @get('loyaltyProgram')
      kind = loyaltyProgram.get('selectedKind.name')
      loyaltyProgram.set('kind', kind)

      
    cancel: ->
      loyaltyProgram = @get('loyaltyProgram')

      if loyaltyProgram.get('isDirty') or loyaltyProgram.get('isNew')
        return unless confirm Em.I18n.t 'loyalty.confirm.cancel'
        loyaltyProgram = @get('loyaltyProgram')
        loyaltyProgram.rollback()

      @send('goBackToLoyaltiesList')
      false

    saveLoyalty: ->
      @set('isLoading', true)
      loyaltyProgram = @get('loyaltyProgram')
      wasNew = loyaltyProgram.get('isNew')

      statusText = Em.I18n.t "loyalty.notifier.status.#{if wasNew then 'new' else 'old'}"
      additionalFields = loyaltyProgram.get('additionalFields').reduce (acc, field) => 
        acc[field.name] = if field.isNumber then Number field.value else field.value
        acc
      ,{}
      loyaltyProgram.set('details', additionalFields)
      loyaltyProgram.save()
      .then =>
        @set('isLoading', false)
        @transitionToRoute('loyalty-programs')
        loyaltyProgram.reload()
        @get('notifier').pushNotification
          type:     'success'
          title:    Em.I18n.t 'loyalty.notifier.title', text: statusText
          duration: 3000

      false

    deleteLoyalty: ->
      @set('isLoading', true)
      return unless confirm Em.I18n.t 'loyalty.confirm.delete'
      loyalty = @get('loyaltyProgram')
      loyalty.destroyRecord()
      .then =>
        @set('isLoading', false)
        @transitionToRoute('loyalty-programs')

      false
